import BITSAT_LOGO from '../../assets/bitsat_logo.png';

const JEE_NEET_LOGO_URL = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSU0wH3rJaZeOOfsC8dT4BqPAGvTnawNOqrAQ&s';
const NDA_LOGO_URL = 'https://upload.wikimedia.org/wikipedia/commons/6/6e/National_Defence_Academy_NDA.png';


/**
 * Represents JEE (engineering) with the official logo.
 */
export const JEELogo = (props) => (
    <img src={JEE_NEET_LOGO_URL} alt="JEE Logo" {...props} />
);

/**
 * Represents NEET (medical) with the official logo.
 */
export const NEETLogo = (props) => (
    <img src={JEE_NEET_LOGO_URL} alt="NEET Logo" {...props} />
);

/**
 * Represents BITSAT (technology/engineering) with the official logo.
 */
export const BITSATLogo = (props) => (
    <img src={BITSAT_LOGO} alt="BITSAT Logo" {...props} />
);

/**
 * Represents NDA with the official logo.
 */
export const NDALogo = (props) => (
    <img src={NDA_LOGO_URL} alt="NDA Logo" {...props} />
);

/**
 * Represents VITEEE with the official logo.
 */
export const VITEEELogo = (props) => (
    <img src="https://imgs.search.brave.com/M9cxyJ4gfVx5t7c6y6aNlI7yVFW8r6rJ_CIQJLnk5Cc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzL2M2L2My/L2U5L2M2YzJlOTAy/MmYyNWY0MDRmZTEw/OGE0Y2ZlZmFiMjIy/LmpwZw" alt="VITEEE Logo" {...props} />
);